import { TYPES } from "./order_bailiff.type";

const initState = {
  orderBailiffAll: null,
  orderBailiffOpenAdd: false,
  orderBailiffOpenEdit: false,
  orderBailiffSelected: null,
  orderBailiffSearch: "",
  //
  orderBailiffQR: null,
  orderBailiffOpenPayment: false,
};

const orderBailiffReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_ORDER_BAILIFF_OPEN_PAYMENT:
      return {
        ...state,
        orderBailiffOpenPayment: payload,
      };

    case TYPES.SET_ORDER_BAILIFF_QR:
      return {
        ...state,
        orderBailiffQR: payload,
      };

    case TYPES.SET_ORDER_BAILIFF_ALL:
      return {
        ...state,
        orderBailiffAll: payload,
      };

    case TYPES.SET_ORDER_BAILIFF_OPEN_ADD:
      return {
        ...state,
        orderBailiffOpenAdd: payload,
      };

    case TYPES.SET_ORDER_BAILIFF_OPEN_EDIT:
      return {
        ...state,
        orderBailiffOpenEdit: payload,
      };

    case TYPES.SET_ORDER_BAILIFF_SELECTED:
      return {
        ...state,
        orderBailiffSelected: payload,
      };

    case TYPES.SET_ORDER_BAILIFF_SEARCH:
      return {
        ...state,
        orderBailiffSearch: payload,
      };

    default:
      return state;
  }
};

export default orderBailiffReducer;
